export function heroes() {
  /**
   * Make homepage hero clickable
   */
  if (document.getElementById("homepage-hero")) {
    document.getElementById("homepage-hero").addEventListener("click", (e) => {
      document.querySelector("#homepage-hero a:first-of-type").click();
    });
  }
}
